module.exports = __webpack_public_path__ + "img/weipinghui.34a654cb.png";